module.exports = __webpack_public_path__ + "img/7@2x.41acdbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/7@2x.png
// module id = /A/d
// module chunks = 0